import { currentViewAs, exitViewAs } from '~/lib/viewAs';
import { useT } from '~/i18n';

/**
 * La franja de «Ver como» (lib/viewAs.ts). Pegada al pie de la pantalla y en coral:
 * quien la ve es del equipo y tiene que saber en todo momento que lo que tiene
 * enfrente NO es su cuenta. Sin vista activa no dibuja nada.
 */
export default function ViewAsBanner() {
  const t = useT('common').viewAs;
  const viewAs = currentViewAs();
  if (!viewAs) return null;

  const who = viewAs.name && viewAs.email
    ? `${viewAs.name} (${viewAs.email})`
    : viewAs.email || viewAs.name || t.someone;

  return (
    <div
      role="status"
      className="sticky bottom-0 z-50 flex flex-wrap items-center justify-center gap-x-3 gap-y-1 px-4 py-2 text-sm"
      style={{ background: 'var(--coral-ink)', color: '#fff' }}
    >
      <strong>{t.label(who)}</strong>
      <span className="opacity-90">{t.readOnly}</span>
      <button
        type="button"
        className="btn btn-xs"
        onClick={exitViewAs}
      >
        {t.exit}
      </button>
    </div>
  );
}
